import React from "react";

const MetadataFields = ({ metadata }) => {
    return (
        <div style={{ marginTop: "20px" }}>
            <strong>Metadata:</strong>
            <hr />
            {metadata.map((item, index) => (
                <div key={index}>
                    <strong>{item.name}: </strong>
                    <span>{item.value}</span>
                </div>
            ))}
        </div>
    );
};

export default MetadataFields;
